import isEmpty from "@/components/helpers/isEmpty"
import { NavigationActions } from "@/components/navigation/ducks/slice"
import {
  ADD_USER_EMAIL,
  CHANGE_PASSWORD_LOGGED_IN,
  FETCH_SUBSCRIPTIONS,
  FETCH_USER_EMAIL_ADDRESSES,
  REMOVE_USER_EMAIL,
  receiveSubscriptions,
  receiveUserEmailAddresses,
  SAVE_SUBCRIPTION_SETTINGS,
  UPDATE_ORG_SETTINGS,
  UPDATE_STRIPE_GIVING,
} from "@/components/privacy/ducks/Actions"
import {
  addUserEmail,
  apiFetchSubscriptions,
  apiFetchUserEmailAddresses,
  apiSaveSubscriptionSettings,
  apiUpdateStripeGiving,
  changePasswordLoggedIn,
  removeUserEmail,
  updateOrgSettings,
} from "@/components/privacy/ducks/AJAX"
import { receiveUpdateUser } from "@/components/profile/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveUserEmailAddressesSuccess = (response) => {
    dispatch(receiveUserEmailAddresses(response.emailAddresses))
  }

  const receiveChangePasswordSuccess = (cb) => (response) => {
    if (response.result) {
      dispatch(NavigationActions.setSnackbar(response.result))
    }
    if (cb) {
      cb()
    }
  }

  const receiveUpdateOrgSettingsSuccess = (cb) => (response) => {
    dispatch(receiveUpdateUser(response))
    if (cb) {
      cb()
    }
  }
  const receiveSubscriptionsSuccess = (cb) => (response) => {
    dispatch(receiveSubscriptions(response))
    if (cb) {
      cb()
    }
  }

  const receiveAddUserEmailSuccess = (cb) => (response) => {
    if (response.currentUser) {
      dispatch(receiveUpdateUser(response.currentUser))
    }
    if (response.emailAddresses) {
      dispatch(receiveUserEmailAddresses(response.emailAddresses))
    }
    if (response.result) {
      dispatch(NavigationActions.setSnackbar(response.result))
    }
    if (cb) {
      cb()
    }
  }
  const receiveRemoveUserEmailSuccess = (response) => {
    if (response.emailAddresses) {
      dispatch(receiveUserEmailAddresses(response.emailAddresses))
    }
    if (response.result) {
      dispatch(NavigationActions.setSnackbar(response.result))
    }
  }

  switch (action.type) {
    case FETCH_USER_EMAIL_ADDRESSES:
      apiFetchUserEmailAddresses(receiveUserEmailAddressesSuccess)
      return next(action)

    case CHANGE_PASSWORD_LOGGED_IN:
      changePasswordLoggedIn(
        action.currentPassword,
        action.newPassword,
        action.confirmNewPassword,
        receiveChangePasswordSuccess(action.success),
        action.error,
      )
      return next(action)

    case ADD_USER_EMAIL:
      addUserEmail(action.payload, receiveAddUserEmailSuccess(action.success), action.error)
      return next(action)

    case REMOVE_USER_EMAIL:
      removeUserEmail(action.email, receiveRemoveUserEmailSuccess)
      return next(action)

    case UPDATE_ORG_SETTINGS:
      updateOrgSettings(
        action.settings,
        receiveUpdateOrgSettingsSuccess(action.success),
        action.error,
      )
      return next(action)
    case SAVE_SUBCRIPTION_SETTINGS:
      apiSaveSubscriptionSettings(
        action.subscriptions,
        receiveSubscriptionsSuccess(action.success),
        action.error,
      )
      return next(action)

    case FETCH_SUBSCRIPTIONS: {
      const { subscriptions } = store.getState().privacy.user

      if (isEmpty(subscriptions)) {
        apiFetchSubscriptions(receiveSubscriptionsSuccess(action.success))
      }
      return next(action)
    }
    case UPDATE_STRIPE_GIVING:
      apiUpdateStripeGiving(action.params, action.success, action.error)
      return next(action)

    default:
      return next(action)
  }
}
